import { Status, StatusType } from 'types/status';

export const SET_STATUS = 'SET_STATUS';
export const CLEAR_STATUS = 'CLEAR_STATUS';

export const clearStatus = (): DataAction => {
    return {
        type: CLEAR_STATUS,
        data: <Status> {
            message: '',
            title: '',
            type: StatusType.None
        }
    };
};

export const setStatus = (type: StatusType, title: string, message: string): DataAction => {
    return {
        type: SET_STATUS,
        data: <Status> {
            message,
            title,
            type
        }
    };
};



// WEBPACK FOOTER //
// ./src/actions/status.ts